<!--
 * @Author: Shen Kui
 * @LastEditTime: 2022-11-30 10:10:11
 * @Description:
-->
<template>
  <div class="w-100 h-100" id="tag-list">
    <div class="w-100 h-100" v-if="showListData">
      <div class="list-content p-10">
        <el-row :gutter="10" type="flex" align="middle">
          <el-col :span="22">
            <el-input
              v-model="searchKey"
              placeholder="标签文字或型号搜索"
              clearable
              size="small"
            ></el-input>
          </el-col>
          <el-col :span="2" class="tr">
            <el-tooltip effect="dark" content="搜索" placement="top">
              <el-button
                type="primary"
                class="iconfont icon-search"
                @click="filterNodeList"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
        <div class="table-content m-t-10">
          <el-table
            :data="dataList"
            v-loading="tableLoading"
            class="w-100"
            height="100%"
            @select="selectionTableChange"
            ref="nodeTable"
          >
            <el-table-column type="selection" align="center" width="55"></el-table-column>
            <el-table-column type="index" label="序号" align="center" width="55"></el-table-column>
            <el-table-column
              label="标签文字"
              show-overflow-tooltip
              align="center"
              prop="code.tagInfo.text"
            ></el-table-column>
            <el-table-column label="标签样式" align="center" prop="code.model"> </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="card-footer w-100 m-t-10 m-b-10">
        <el-row type="flex" align="middle" class="w-100">
          <el-col :span="12"
            ><el-button type="primary" size="mini" @click="addNode">新增</el-button></el-col
          >
          <el-col :span="12" class="tr"
            ><el-button type="primary" size="mini" @click="editNode">修改</el-button
            ><el-button type="primary" size="mini" @click="deleteNode">删除</el-button></el-col
          >
        </el-row>
      </div>
    </div>
    <div class="w-100 h-100" v-else>
      <div class="tag-list-content p-10">
        <el-row :gutter="10" type="flex" align="middle" class="m-t-10">
          <el-col :span="4">
            <span class="fz-12">标签样式</span>
          </el-col>
          <el-col :span="18" class="tr">
            <el-input
              v-model="searchTypeKey"
              placeholder="名称搜索"
              clearable
              size="small"
            ></el-input>
          </el-col>
          <el-col :span="2" class="tr">
            <el-tooltip effect="dark" content="搜索" placement="top">
              <el-button
                type="primary"
                class="iconfont icon-search"
                @click="getDataList"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
        <div class="model-list m-t-10" v-loading="listLoading">
          <el-row>
            <el-col :span="8" v-for="(item, index) in deviceList" :key="index">
              <div class="w-100 model-item p-10 cur-pointer">
                <div class="w-100 item-img">
                  <img
                    class="w-100 h-100"
                    :src="`${currentEnv.VUE_APP_PLANT_SERVER}${item.thumbnails}`"
                    width="100%"
                    height="100%"
                    alt=""
                  />
                </div>
                <div
                  class="w-100 item-title ell tc"
                  @click="
                    (e) => {
                      e.stopPropagation()
                    }
                  "
                >
                  <el-checkbox
                    v-model="item.select"
                    @change="selectChange(item)"
                    class="text-color-white d-flex flex-align-center flex-row-center m-t-5"
                    >{{ item.name }}</el-checkbox
                  >
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="tag-edit w-100 m-t-10 p-10">
        <el-row>
          <el-col :span="4"><span class="fz-12">文字输入</span></el-col>
          <el-col :span="20"
            ><el-input
              type="textarea"
              v-model="textareaText"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder=""
            ></el-input
          ></el-col>
        </el-row>
        <el-row class="m-t-10" type="flex" align="middle">
          <el-col :span="2"><span class="fz-12">字号</span></el-col>
          <el-col :span="8">
            <el-input-number
              v-model="fontSizeValue"
              :min="0"
              size="mini"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="2"><span class="fz-12">字体</span></el-col>
          <el-col :span="8">
            <el-select
              v-model="fontFamilyValue"
              placeholder="字体"
              size="mini"
              filterable
              clearable
              popper-class="document_select-popper"
            >
              <el-option
                v-for="item in fontFamilyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option> </el-select
          ></el-col>
          <el-col :span="4" class="tr">
            <el-color-picker v-model="fontColor" size="mini"></el-color-picker>
          </el-col>
        </el-row>
        <el-row class="m-t-10" type="flex" align="middle">
          <el-col :span="2"><span class="fz-12">行距</span></el-col>
          <el-col :span="8">
            <el-input-number
              v-model="lineHeightValue"
              :min="0"
              size="mini"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="2"><span class="fz-12">边距</span></el-col>
          <el-col :span="8">
            <el-input-number
              v-model="marginValue"
              :min="0"
              size="mini"
              class="w-100"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="4"></el-col>
        </el-row>
        <el-row class="m-t-10" type="flex" align="middle">
          <el-col :span="2"><span class="fz-12">宽度</span></el-col>
          <el-col :span="8">
            <el-input-number
              v-model="imageWidthValue"
              :min="0"
              size="mini"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="2"><span class="fz-12">高度</span></el-col>
          <el-col :span="8">
            <el-input-number
              v-model="imageHeightValue"
              :min="0"
              size="mini"
              class="w-100"
              controls-position="right"
            ></el-input-number
          ></el-col>
          <el-col :span="4"></el-col>
        </el-row>
        <el-row class="m-t-10" type="flex" align="middle">
          <el-col :span="10">
            <div class="horizontal-align d-flex">
              <i
                class="iconfont fz-16 tc m-r-5 cur-pointer"
                @click="checkHorizontalAlign(item)"
                :class="[item.icon, { selectIcon: horizontalAlignValue === item.align }]"
                :key="item.align"
                v-for="item in horizontalAlignSettings"
              ></i>
            </div>
          </el-col>
          <el-col :span="8" class="d-flex flex-row-center">
            <div class="vertical-align d-flex">
              <i
                class="iconfont fz-16 tc m-r-5 cur-pointer"
                @click="checkVerticalAlign(item)"
                :class="[item.icon, { selectIcon: verticalAlignValue === item.align }]"
                :key="item.align"
                v-for="item in verticalAlignSettings"
              ></i>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="font-style d-flex flex-row-end">
              <i
                class="iconfont fz-14 tc m-l-5 cur-pointer icon-bold"
                @click="fontBold = !fontBold"
                :class="{ selectIcon: fontBold }"
              ></i>
              <i
                class="iconfont fz-14 tc m-l-5 cur-pointer icon-underline"
                @click="fontUnderline = !fontUnderline"
                :class="{ selectIcon: fontUnderline }"
              ></i>
            </div>
          </el-col>
        </el-row>

        <div class="w-100 m-t-10">
          <div class="btn_file cur-pointer w-100 tc">
            <span>批量创建</span>
            <input
              type="file"
              id="fileInput"
              name="file"
              accept=".xls,.xlsx"
              @change="fileInputChange"
            />
          </div>
        </div>
      </div>
      <div class="card-footer w-100 m-t-10">
        <el-row type="flex" align="middle">
          <el-col :span="9">
            <div
              @click="
                (e) => {
                  e.stopPropagation()
                }
              "
            >
              <el-radio-group v-model="addTypeValue" class="d-flex flex-align-center">
                <el-radio size="small" :label="1">锚点位置</el-radio>
                <el-radio size="small" :label="2">按节点</el-radio>
              </el-radio-group>
            </div>
          </el-col>
          <el-col :span="8" class="p-l-5 p-r-5">
            <el-select
              v-model="nodePositionValue"
              placeholder="中心"
              size="mini"
              popper-class="document_select-popper"
            >
              <el-option
                v-for="item in nodePostionProp"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="7" class="tr"
            ><el-button size="mini" @click="cancleModify">取消</el-button>
            <el-button type="primary" size="mini" @click="loadInstrumentNode"
              >新增</el-button
            ></el-col
          >
        </el-row>
      </div>
    </div>
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
  </div>
</template>
<script>
import XLSX from 'xlsx'
import DocumentManagementService from '@/services/documentManagement'
import ApiMixinDocuments from '@/assets/js/api/documents'
import ApiMixinDocumentList from '@/assets/js/api/documentList'
import { isJSONObj, loadFbxModel, loadPrModel, generateGUID } from '../../../js/engineerSceneData'

const PlayerProgress = () => {
  return import('@/components/model/PlayerProgress')
}
export default {
  components: { PlayerProgress },
  name: 'SwitchList',
  data() {
    return {
      showLoadProgress: false,
      loadPercentage: 0,
      loadType: '',
      horizontalAlignValue: 'left',
      verticalAlignValue: 'top',
      imageWidthValue: 500,
      imageHeightValue: 50,
      fontBold: false,
      fontUnderline: false,
      horizontalAlignSettings: [
        {
          align: 'left',
          icon: 'icon-align-left',
        },
        {
          align: 'center',
          icon: 'icon-center',
        },
        {
          align: 'right',
          icon: 'icon-align-right',
        },
      ],
      verticalAlignSettings: [
        {
          align: 'bottom',
          icon: 'icon-align-bottom',
        },
        {
          align: 'middle',
          icon: 'icon-vertically',
        },
        {
          align: 'top',
          icon: 'icon-top-vertically',
        },
      ],
      currentCreateParams: {}, // 添加模型参数
      lineHeightValue: 0, // 行距
      marginValue: 0, // 边距
      fontSizeValue: 12, // 字号
      fontFamilyValue: 'sans-serif', // 字体
      fontColor: '#000000', // 字体颜色
      fontFamilyOptions: [
        { label: 'sans-serif', value: 'sans-serif' },
        { label: '宋体', value: 'SimSun' },
        { label: '黑体', value: 'SimHei' },
        { label: '微软雅黑', value: 'Microsoft YaHei' },
        { label: '微软正黑体', value: 'Microsoft JhengHei' },
        { label: '新宋体', value: 'NSimSun' },
        { label: '新细明体', value: 'PMingLiU' },
        { label: '细明体', value: 'MingLiU' },
        { label: '标楷体', value: 'DFKai-SB' },
        { label: '仿宋', value: 'FangSong' },
        { label: '楷体', value: 'KaiTi' },
        { label: '仿宋_GB2312 ', value: 'FangSong_GB2312' },
        { lable: '楷体_GB2312', value: 'KaiTi_GB2312' },
      ], //
      textareaText: '',
      listLoading: false,
      selectionNode: null,
      searchKey: '',
      currentNodeName: '', // 对象名称
      searchTypeKey: '', // 列表搜索
      showListData: true,
      dataList: [],
      orignList: [], // 原始数据
      deviceList: [],
      tableLoading: false,
      defaultFolderId: null, // 仪器的文件路径id
      templateAttrSetList: [],
      addTypeValue: 1, // 添加类型
      nodePositionValue: 'YN', // 节点位置
      nodePostionProp: [
        {
          value: 'Z',
          label: '上方',
        },
        {
          value: 'ZN',
          label: '下方',
        },
        {
          value: 'YN',
          label: '前方',
        },
        {
          value: 'Y',
          label: '后方',
        },
        {
          value: 'XN',
          label: '左方',
        },
        {
          value: 'X',
          label: '右方',
        },
      ],
      uploadDataList: [],
      currentUplodLoadParams: {},
      currentCalcAabb: {},
      currentIndex: 0,
      tagCount: 0,
      currentTagPosition: [],
      currentModelMd5: '',
      currentModelFile: '',
      currentModelParams: {},
      currentModelMaterialParams: {},
      currentCreateNode: '',
    }
  },
  props: ['player', 'updateNode', 'watchNodeModify', 'currentNodeData'],
  mixins: [ApiMixinDocuments, ApiMixinDocumentList],
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || this.$store.getters['Sites/currentProject'] || {}
    },
    systemParams() {
      return this.$store.getters.systemParams || []
    },
    DevicesLibrariesFolder() {
      const path = _.find(this.systemParams, { parameterCode: 'DevicesLibrariesFolder' }) || {}
      return path.parameterValue || null
    },
    DevicesClassId() {
      const parameter = _.find(this.systemParams, { parameterCode: 'DevicesClass' }) || {}
      return parameter ? parameter.parameterValue : ''
    },
  },
  watch: {
    updateNode() {
      this.getTagList()
    },
    watchNodeModify() {
      this.getTagList()
    },
    currentNodeData: {
      handler() {
        this.$nextTick(() => {
          this.getTagList()
        })
      },
      deep: true,
    },
    tagCount(val) {
      if (!_.isNil(this.uploadDataList[this.currentIndex])) {
        this.addModel(
          this.currentModelMd5,
          this.currentModelFile,
          this.currentModelParams,
          this.currentModelMaterialParams
        )
      } else {
        this.currentIndex = 0
        this.uploadDataList = []
        this.tagCount = 0
        this.currentCalcAabb = {}
        this.$emit('updateEditTree', this.currentCreateNode)
      }
    },
  },
  async created() {
    this.getTagList()
    await this.getFolderClassId()
    // 获取属性模板
    await this.getAttributeTemplateList()
    // 获取仪器列表
    this.getDataList()
  },
  mounted() {
    const res = XLSX.read('', { type: 'binary' })
  },
  methods: {
    // 文件上传
    fileInputChange(e) {
      const fileReader = new FileReader()
      fileReader.onload = (event) => {
        const { result } = event.target
        const data = XLSX.read(result, { type: 'binary' })
        this.uploadDataList = this.sheetToArray(data.Sheets.Sheet1)
        if (!_.isEmpty(this.uploadDataList)) {
          const isSelectList = _.filter(this.deviceList, ['select', true])
          this.currentUplodLoadParams = {
            modifyNode: this.selectionNode,
            documentDataList: isSelectList,
            type: 'Tag',
            name: this.currentNodeName,
            positionType: this.addTypeValue === 1 ? 'anchor' : 'faceCenter',
            faceValue: this.nodePositionValue,
          }
          this.createNode(this.currentUplodLoadParams)
        }
      }
      fileReader.readAsBinaryString(e.target.files[0])
      $('#fileInput').val('')
    },
    // 表格转二维数组
    sheetToArray(sheet) {
      const range = {
        x1: sheet['!ref'].split(':')[0].match(/^[A-Z]+/)[0],
        y1: sheet['!ref'].split(':')[0].match(/\d+$/)[0],
        x2: sheet['!ref'].split(':')[1].match(/^[A-Z]+/)[0],
        y2: sheet['!ref'].split(':')[1].match(/\d+$/)[0],
      }
      const tableDataArr = []
      for (let y = Number(range.y1); y <= Number(range.y2); y += 1) {
        const rows = []
        for (let x = range.x1.charCodeAt(); x <= range.x2.charCodeAt(); x += 1) {
          const position = String.fromCharCode(x) + y
          rows.push(sheet[position] ? sheet[position].v : null)
        }
        tableDataArr.push(rows)
      }
      return tableDataArr
    },
    // 选择水平对齐方式
    checkHorizontalAlign(item) {
      this.horizontalAlignValue = item.align
    },
    // 选择垂直对齐方式
    checkVerticalAlign(item) {
      this.verticalAlignValue = item.align
    },
    // 表格选择
    selectionTableChange(selections, row) {
      this.$refs.nodeTable.clearSelection()
      this.selectionNode = row
      this.$refs.nodeTable.toggleRowSelection(row, true)
    },
    // 表格筛选
    filterNodeList() {
      this.dataList = _.filter(this.orignList, (item) => {
        return (
          item.code.tagInfo.text.search(this.searchKey) >= 0 ||
          item.code.model.search(this.searchKey) >= 0
        )
      })
    },
    // 选择模型切换
    selectChange(data) {
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
      data.select = true
    },
    // 获取仪器列表
    async getTagList() {
      // 获取当前选中模型子级
      const subNodes = await this.player.Native.NodeProxy.getNodeChildren(
        this.currentNodeData.nodePtr
      )
      const filterList = _.filter(subNodes, (val) => {
        return val.code && isJSONObj(val.code) && JSON.parse(val.code).type === 'Tag'
      })
      this.orignList = _.map(filterList, (el) => {
        return {
          code: JSON.parse(el.code),
          id: el.id,
          item: el.item,
          name: el.name,
          nodePtr: el.nodePtr,
          parentPtr: el.parentPtr,
          type: el.type,
        }
      })
      this.dataList = _.cloneDeep(this.orignList)
    },
    // 加载仪器模型节点
    async loadInstrumentNode() {
      this.uploadDataList = []
      const isSelectList = _.filter(this.deviceList, ['select', true])
      const params = {
        modifyNode: this.selectionNode,
        documentDataList: isSelectList,
        type: 'Tag',
        name: this.currentNodeName,
        positionType: this.addTypeValue === 1 ? 'anchor' : 'faceCenter',
        faceValue: this.nodePositionValue,
      }
      this.createNode(params)
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
    },
    // 加载模型
    async createNode(data) {
      if (_.isEmpty(data.documentDataList)) {
        this.$message.warning('请选择设备进行添加')
        return
      }
      this.currentCreateParams = _.cloneDeep(data)
      if (this.currentCreateParams.positionType === 'anchor') {
        this.nodePosition = await this.player.Native.Camera.getAnchorPos()
      } else if (this.currentCreateParams.positionType === 'faceCenter') {
        if (this.currentNodeData.item) {
          const calcData = await this.player.Native.ModelTree.calcItemAabbData(
            this.currentNodeData.item
          )
          this.nodePosition = Aabb.faceCenter(calcData.aabb, this.currentCreateParams.faceValue)
        } else {
          this.$message.warning('请选择节点')
          return
        }
      }
      this.currentTagPosition = _.cloneDeep(this.nodePosition)
      _.forEach(this.currentCreateParams.documentDataList, (item) => {
        this.getDocumentFileList(item)
      })
    },
    // 获取查找文档关联文件
    async getDocumentFileList(data) {
      const res = await DocumentManagementService.getFileList({
        id: data.id,
      })
      if (res && res.data) {
        this.checkModel(res.data)
      }
    },
    /**
     * @description: 检查是否模型是否存在 不存在则下载
     * @param {*}
     * @return {*}
     */
    async checkModel(modelParams) {
      const currentModelFile = _.find(modelParams, (item) => {
        return item.fileType === '.pr' || item.fileType === '.fbx'
      })
      if (!currentModelFile) {
        this.$message.error('当前项目没有模型')
        return
      }
      const currentZip = _.find(modelParams, ['fileType', '.zip'])
      if (currentZip) {
        this.checkModelMaterial(currentZip, currentModelFile)
      } else {
        this.getCurrentModelFile(currentModelFile, {})
      }
    },

    // 检查模型材质文件
    async checkModelMaterial(item, modelParams) {
      // eslint-disable-next-line no-await-in-loop
      const result = await this.player.Native.File.getFileMd5(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`
      )
      const exists = await this.player.Native.File.exists(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`
      )
      if (item.md5 === result && exists) {
        this.getCurrentModelFile(modelParams, item)
      } else {
        this.downloadMaterialFile(item.md5, item, modelParams)
      }
    },

    // 检查模型是否存在
    getCurrentModelFile(item, materialParams) {
      const fileUrl = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}${item.fileType}`
      this.player.Native.File.getFileMd5(fileUrl, (res) => {
        if (res === item.md5) {
          // 有模型就加载模型
          this.addModel(item.md5, fileUrl, item, materialParams)
        } else {
          // 校验md5失败
          this.downloadFile(item.md5, item.fileType, item, materialParams)
        }
      })
      this.currentModelMd5 = item.md5
      this.currentModelFile = fileUrl
      this.currentModelParams = item
      this.currentModelMaterialParams = materialParams
    },

    // 下载材质文件
    async downloadMaterialFile(md5, item, modelParams) {
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(
        this.downloadMaterialMsg(modelParams.md5, item, modelParams)
      )
      const res = await this.player.Native.File.downloadFile(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`,
        'GET',
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${md5}`,
        { Authorization: `${this.fullToken}` }
      )
      // 代表创建下载任务成功
      if (res) {
        this.showLoadProgress = true
        this.loadType = '下载中...'
      } else {
        this.$message.warning('下载材质文件失败')
      }
    },

    /**
     * @description: 下载模型
     * @param {*} playerName：模型名称
     * @param {*} type： 模型类型
     * @return {*}
     */
    async downloadFile(md5, type, item, materialParams) {
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(
        this.downloadMsg(md5, item, type, materialParams)
      )
      this.player.Native.File.downloadFile(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`,
        'GET',
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${md5}`,
        { Authorization: `${this.fullToken}` },
        (res) => {
          // 代表创建下载任务成功
          if (res) {
            this.showLoadProgress = true
            this.loadType = '下载中...'
          } else {
            this.$message.warning('下载模型失败')
          }
        }
      )
    },
    // 监听下载模型是否成功
    downloadMsg(md5, item, type, materialParams) {
      const that = this
      const fun = async (file, err) => {
        that.loadPercentage = 0
        that.showLoadProgress = false
        if (err) {
          that.$message.warning(`下载文件失败，${file}, ${err}`)
          return
        }
        if (
          file ===
          `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`
        ) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          that.player.Native.File.EventDownloadProcessChanged.disconnect(that.progressMsg)
          // 检查当前md5和远程下载的md5是否一致
          that.player.Native.File.getFileMd5(
            `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`,
            (res) => {
              if (res !== md5) {
                that.$message.warning('当前请求的md5和服务器下载的md5不一致！')
              }
            }
          )
          that.addModel(md5, file, item, materialParams) // 模型下载成功就加载模型
        }
      }
      return fun
    },

    // 监听下载模型是否成功
    downloadMaterialMsg(md5, item, modelParams) {
      const that = this
      const fun = async (file, err) => {
        that.showLoadProgress = false
        that.loadPercentage = 0
        if (err) {
          that.$message.warning(`下载材质文件失败，${file}, ${err}`)
          return
        }
        if (
          file === `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}.zip`
        ) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          that.player.Native.File.EventDownloadProcessChanged.disconnect(that.progressMsg)
          await this.player.Native.UiQt.decompressingZIP(file, '')
          setTimeout(() => {
            that.getCurrentModelFile(modelParams, item)
          }, 1500)
        }
      }
      return fun
    },

    // 监听下载进度
    progressMsg(file, bytesReceived, bytesTotal) {
      if (bytesTotal) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      }
    },
    checkModelLoad(data) {
      this.loadType = '加载中...'
      this.showLoadProgress = true
      this.loadPercentage = data * 100
    },
    /**
     * @description: 监听模型加载完成
     * @param {*} data
     * @return {*}
     */
    checkModelLoadEnd(data) {
      this.showLoadProgress = false
      this.player.Native.Model.EventProgress.disconnect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
    },
    // 获取文档属性模板信息
    async getDocDetail(id) {
      const res = await DocumentManagementService.getDocumentEdite({
        id,
      })
      if (res && res.code === 0 && res.data) {
        if (!_.isEmpty(res.data.templateAttrSetList)) {
          const val = _.find(res.data.templateAttrSetList[0].attrValueList, (el) => {
            return el.fieldName === 'type'
          })
          return val ? val.attrValue : ''
        }
      }
      return ''
    },
    // 加载模型
    async addModel(md5, url, item, materialParams) {
      this.player.Native.Model.EventProgress.connect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      const modelName = await this.getDocDetail(item.documentId)
      const rootItems = await this.player.Native.ModelTree.getRootItems()
      const currentRoot = _.find(rootItems, (val) => {
        return val.code && JSON.parse(val.code) && JSON.parse(val.code).type === 'Root'
      })
      const rootNode =
        !_.isNil(currentRoot) && currentRoot.nodePtr
          ? currentRoot.nodePtr
          : await this.player.Native.NodeProxy.rootNode()
      let parentNode = this.currentNodeData.nodePtr ? this.currentNodeData.nodePtr : rootNode
      if (this.currentCreateParams.modifyNode && this.currentCreateParams.modifyNode.nodePtr) {
        const editNode = await this.player.Native.NodeEditor.node()
        if (editNode === this.currentCreateParams.modifyNode.nodePtr) {
          await this.player.Native.NodeEditor.setNode(0)
        }
        await this.player.Native.NodeProxy.destroyNode(this.currentCreateParams.modifyNode.nodePtr)
        if (this.currentNodeData.nodePtr === this.currentCreateParams.modifyNode.nodePtr) {
          parentNode = this.currentCreateParams.modifyNode.parentPtr
        }
      }
      if (item.fileType === '.pr') {
        this.currentCreateNode = await loadPrModel(
          url,
          this.currentCreateParams.name || item.documentName,
          parentNode,
          this.player
        ) // 加载模型
      } else if (item.fileType === '.fbx') {
        this.currentCreateNode = await loadFbxModel(
          url,
          this.currentCreateParams.name || item.documentName,
          parentNode,
          this.player
        )
      } else {
        this.currentCreateNode = await this.player.Native.NodeProxy.loadModelNode(
          parentNode,
          url,
          this.currentCreateParams.name || item.documentName
        ) // 加载模型
      }
      if (this.currentCalcAabb.aabb) {
        const leftFace = Aabb.faceCenter(this.currentCalcAabb.aabb, 'XN')
        const rightFace = Aabb.faceCenter(this.currentCalcAabb.aabb, 'X')
        const topFace = Aabb.faceCenter(this.currentCalcAabb.aabb, 'Z')
        const bottomFace = Aabb.faceCenter(this.currentCalcAabb.aabb, 'ZN')
        this.currentTagPosition = [
          this.nodePosition[0] + this.tagCount * (rightFace[0] - leftFace[0]),
          this.nodePosition[1],
          this.nodePosition[2] + this.currentIndex * (bottomFace[2] - topFace[2]),
        ]
      }
      await this.player.Native.NodeProxy.setGlobalTranslation(
        this.currentCreateNode,
        _.isEmpty(this.uploadDataList) ? this.nodePosition : this.currentTagPosition
      )
      let text = ''
      if (!_.isEmpty(this.uploadDataList) && this.uploadDataList[this.currentIndex]) {
        text = this.uploadDataList[this.currentIndex][this.tagCount]
      } else {
        text = this.textareaText
      }
      const guid = generateGUID()
      await this.player.Native.NodeProxy.setNodeInfo(this.currentCreateNode, {
        code: JSON.stringify({
          type: this.currentCreateParams.type,
          fileType: item.fileType,
          filePath: url,
          documentId: item.documentId,
          documentName: item.documentName,
          documentCode: item.documentCode,
          md5,
          materialFileMd5: materialParams.md5,
          model: modelName,
          tagInfo: {
            text: text || item.documentName,
            id: guid,
            file: `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${guid}.png`,
          },
        }),
      })
      const nodeInfo = await this.player.Native.NodeProxy.getNodeInfo(this.currentCreateNode)
      if (nodeInfo) {
        this.currentCalcAabb = await this.player.Native.ModelTree.calcItemAabbData(nodeInfo.item)
      }
      if (_.isEmpty(this.uploadDataList)) {
        this.$emit('updateEditTree', this.currentCreateNode)
      }
      this.drawNodeMaterial(this.currentCreateNode, text || item.documentName, md5, guid)
      this.getTagList()
    },
    // 绘制标签贴图
    async drawNodeMaterial(node, name, parentMd5, guid) {
      const url = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${parentMd5}/${guid}.png`
      const canvas = document.createElement('canvas')
      canvas.width = this.imageWidthValue
      canvas.height = this.imageHeightValue
      const ctx = canvas.getContext('2d')
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.font = `${this.fontBold ? 'bold' : ''} ${this.fontSizeValue}px ${this.fontFamilyValue}`
      ctx.textAlign = this.horizontalAlignValue
      ctx.textBaseline = this.verticalAlignValue
      ctx.fillStyle = this.fontColor
      const horizontalOption = {
        center: canvas.width / 2,
        right: canvas.width,
        left: this.marginValue,
      }
      const verticalOption = {
        middle: canvas.height / 2,
        bottom: canvas.height,
        top: this.marginValue,
      }
      const xPos = horizontalOption[this.horizontalAlignValue]
      const yPos = verticalOption[this.verticalAlignValue]
      const chartArr = name.split('')
      let temp = ''
      const rows = []
      for (let i = 0; i < chartArr.length; i += 1) {
        if (
          ctx.measureText(temp).width < canvas.width - this.marginValue &&
          ctx.measureText(temp + chartArr[i]).width <= canvas.width - this.marginValue
        ) {
          temp += chartArr[i]
        } else {
          rows.push(temp)
          temp = chartArr[i]
        }
      }
      rows.push(temp)
      for (let x = 0; x < rows.length; x += 1) {
        ctx.fillText(rows[x], xPos, yPos + x * (this.lineHeightValue + this.fontSizeValue))
        if (this.fontUnderline) {
          let xBeginPos = 0
          let xEndPos = 0
          let yLinePos = 0
          switch (this.horizontalAlignValue) {
            case 'left':
              xBeginPos = this.marginValue
              xEndPos = ctx.measureText(rows[x]).width + this.marginValue
              break
            case 'center':
              xBeginPos = xPos - ctx.measureText(rows[x]).width / 2
              xEndPos = xPos + ctx.measureText(rows[x]).width / 2
              break
            case 'right':
              xBeginPos = canvas.width - ctx.measureText(rows[x]).width
              xEndPos = canvas.width
              break
            default:
              break
          }
          switch (this.verticalAlignValue) {
            case 'top':
              yLinePos = this.fontSizeValue + yPos + x * (this.lineHeightValue + this.fontSizeValue)
              break
            case 'middle':
              yLinePos =
                this.fontSizeValue / 2 + yPos + x * (this.lineHeightValue + this.fontSizeValue)
              break
            case 'bottom':
              yLinePos = yPos
              break
            default:
              break
          }
          ctx.beginPath()
          ctx.moveTo(xBeginPos, yLinePos)
          ctx.lineTo(xEndPos, yLinePos)
          ctx.closePath()
          ctx.strokeStyle = this.fontColor
          ctx.stroke()
        }
      }
      const imgUrl = canvas.toDataURL('image/png')
      canvas.remove()
      this.player.Native.File.EventDownloadFinish.connect(this.downloadImageEnd(node, url)) // 断开下载
      this.player.Native.File.downloadFile(url, 'GET', imgUrl, {})
    },
    downloadImageEnd(node, url) {
      const that = this
      const fun = (file, err) => {
        that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
        this.setNodeMaterial(node, url)
      }
      return fun
    },
    //
    async setNodeMaterial(node, imgUrl) {
      const childNode = await this.player.Native.NodeProxy.getNodeChildren(node)
      const materialPtr = await this.player.Native.NodeProxy.getNodeMaterial(childNode[0].nodePtr)
      if (materialPtr) {
        const copyMaterial = await this.player.Native.NodeProxy.copyMaterial(materialPtr)
        await this.player.Native.NodeProxy.setNodeMaterial(childNode[0].nodePtr, copyMaterial)
        await this.player.Native.NodeProxy.setMaterialTexture(copyMaterial, imgUrl)
      }
      if (!_.isEmpty(this.uploadDataList)) {
        if (this.tagCount >= this.uploadDataList[this.currentIndex].length - 1) {
          this.tagCount = 0
          this.currentIndex += 1
        } else {
          this.tagCount += 1
        }
      }
    },
    // 获取仪器的文件路径id
    async getFolderClassId() {
      const res = await DocumentManagementService.getDocumentTree({
        siteId: this.currentProject.id,
        flag: 2,
        keyword: '标签',
      })
      if (res && res.code === 0 && res.data) {
        const DevicesLibrariesFolder = _.find(res.data, (item) => {
          return item.folderId === this.DevicesLibrariesFolder
        })
        if (DevicesLibrariesFolder) {
          const currentFolder = _.find(DevicesLibrariesFolder.children, (item) => {
            return item.name === '标签'
          })
          if (currentFolder) {
            this.defaultFolderId = currentFolder.folderId
          }
        }
      }
    },
    // 获取属性模板
    async getAttributeTemplateList() {
      const res = await DocumentManagementService.getTemplateByClassId({
        classId: this.DevicesClassId,
      })
      if (res && res.code === 0 && res.data) {
        if (res.data.templateAttrSetList) {
          this.templateAttrSetList = _.cloneDeep(res.data.templateAttrSetList)
        }
      }
    },
    // 获取仪器列表
    async getDataList() {
      if (this.defaultFolderId) {
        this.listLoading = true
        const query = {
          classIds: [],
          endTime: '',
          flag: '',
          folderId: this.defaultFolderId,
          isRecursion: true,
          keyWord: this.searchTypeKey,
          pageno: 1,
          pagesize: 9999,
          searchItems: [],
          siteId: this.currentProject.id,
          startTime: '',
        }
        // // 拼接属性模板搜索条件
        // if (this.templateAttrSetList) {
        //   const attrValue = _.find(this.templateAttrSetList[0].attrValueList, (item) => {
        //     return item.attrbuteDetail.displayName === '型号'
        //   })
        //   query.searchItems = [
        //     {
        //       tableName: this.templateAttrSetList[0].tableName,
        //       tableItems: [
        //         {
        //           fieldName: attrValue.fieldName,
        //           fieldValue: this.searchTypeKey,
        //           valueType: attrValue.valueType,
        //         },
        //       ],
        //     },
        //   ]
        // }
        const res = await DocumentManagementService.advancedSearch(query)
        this.listLoading = false
        if (res && res.code === 0 && res.data) {
          this.deviceList = _.map(res.data.items, (item) => {
            return {
              ...item,
              select: false,
            }
          })
        }
      }
    },
    // 取消编辑
    cancleModify() {
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
      this.selectionNode = null
      this.showListData = true
      setTimeout(() => {
        this.getTagList()
        this.$refs.nodeTable.clearSelection()
      }, 500)
    },
    // 去到新增页面
    addNode() {
      this.showListData = false
    },
    // 去到编辑
    editNode() {
      if (!this.selectionNode) {
        this.$message.warning('请选择模型修改模型')
        return
      }
      this.currentNodeName = this.selectionNode.name
      this.showListData = false
    },
    // 删除节点
    async deleteNode() {
      if (!this.selectionNode) {
        this.$message.warning('请选择需要删除的模型')
        return
      }
      if (this.selectionNode.nodePtr) {
        const editNode = await this.player.Native.NodeEditor.node()
        if (editNode === this.selectionNode.nodePtr) {
          await this.player.Native.NodeEditor.setNode(0)
        }
        await this.player.Native.NodeProxy.destroyNode(this.selectionNode.nodePtr)
        this.selectionNode = null
        this.$refs.nodeTable.clearSelection()
        this.getTagList()
        this.$emit('updateEditTree', '')
      }
    },
  },
}
</script>
<style lang="scss">

@import '../../../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../../../css/index.scss';
/deep/.player_progress {
  position: fixed !important;
}
/deep/ .el-table__header-wrapper .el-checkbox {
  display: none !important;
}
/deep/.el-checkbox__label {
  font-size: 12px !important;
  max-width: 80px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#tag-list {
  color: #fff;
  z-index: 99;
  background-color: transparent;
  .list-content {
    height: calc(100% - 48px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    .table-content {
      height: calc(100% - 42px);
    }
  }
  .tag-edit {
    height: calc(55% - 60px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    overflow-y: auto;
    .horizontal-align,
    .vertical-align,
    .font-style {
      i {
        height: 32px;
        width: 32px;
        line-height: 32px;
        border-radius: 5px;
      }
      .selectIcon {
        background-color: #00c0ff;
      }
    }
  }
  .tag-list-content {
    height: 45%;
    background-color: rgba(24, 41, 72, 0.5) !important;
    .model-list {
      height: calc(100% - 52px);
      overflow-y: auto;
      .model-item {
        height: 120px;
        .item-img {
          height: calc(100% - 30px);
          background-color: #383b3b !important;
        }
        .item-title {
          height: 30px;
          line-height: 30px;
        }
      }
      .model-item:hover {
        background-color: rgba(46, 107, 176, 0.5) !important;
      }
    }
  }
  .card-footer {
    border: none !important;
  }
}
.btn_file {
  position: relative;
  display: inline-block;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  text-decoration: none;
  text-indent: 0;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  height: 32px;
  font-size: 12px;
  line-height: 25px;
  input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
  }
}

</style>
